import { createSlice } from "@reduxjs/toolkit"

const initialStatePagoSinFactura = {
  pagoSinFactura: {
    idLiquidacionWebSinFactura: undefined,
    fechaVto: undefined,
    cuitLetrado: '',
    idJuicio: -1,
    importeTotal: 0,
    pagos: [],
    idDenuncia: -1,
    idUsuarioAlta: -1,
  }
}

let nextIdKey = 1 

export const datosPagoSinFacturaSlice = createSlice({
  name: "datoPagoSinFactura",
  initialState: initialStatePagoSinFactura,
  reducers: {
    setPagoSinFactura: (state, action) => {
      state.pagoSinFactura = { ...state.pagoSinFactura, ...action.payload }
    },
    resetPagoSinFactura: (state) => {
      state.pagoSinFactura = { ...initialStatePagoSinFactura.pagoSinFactura }
    },
    agregarPagoLiq: (state, action) => {
      state.pagoSinFactura.pagos.push({
        ...action.payload,
        idKey: nextIdKey++
      })
    },
    eliminarPagoLiq: (state, action) => {
      state.pagoSinFactura.pagos = state.pagoSinFactura.pagos.filter(
        pago => pago.idKey !== action.payload
      )
    },
    agregarConceptoLiq: (state, action) => {
      const { idPago, conceptos } = action.payload
      const pago = state.pagoSinFactura.pagos.find(p => p.idKey === idPago)
      if (pago) {
        pago.conceptosLiq.push({
          ...conceptos,
          idkey: nextIdKey++
        })
      }
    },
    eliminarConceptoLiq: (state, action) => {
      const { idPago, idConcepto } = action.payload
      const pago = state.pagoSinFactura.pagos.find(p => p.idKey === idPago)
      if (pago) {
        pago.conceptosLiq = pago.conceptosLiq.filter(
          concepto => concepto.idKey !== idConcepto
        )
      }
    },
    setIdLiquidacionSinFactura: (state, action) => {
      state.idLiquidacionWebSinFactura = action.payload
    },
    resetIdLiquidacionSinFactura: (state) => {
      state.idLiquidacionWebSinFactura = initialStatePagoSinFactura.idLiquidacionWebSinFactura
    },
    validarDatosPagoSinFactura: (state) => {
      const pagoSinFactura = state.pagoSinFactura

      if (!pagoSinFactura.fechaVto)
        throw new Error("La fecha de investigación es obligatoria")

      if (!pagoSinFactura.cuitLetrado)
        throw new Error("La cuit del letrado es obligatoria")

      if (!pagoSinFactura.pagos || pagoSinFactura.pagos.length === 0)
        throw new Error("Debe ingresar al menos un pago")

      if (+pagoSinFactura.idJuicio === -2 || pagoSinFactura.idJuicio === undefined)
        throw new Error("El proceso judicial es obligatorio")

      const hayConceptos = pagoSinFactura.pagos.some(p => p.conceptosLiq && p.conceptosLiq.length > 0)
      if (!hayConceptos)
        throw new Error("Debe ingresar al menos un concepto de la liquidación");
    }
  }
})

export const {
  setPagoSinFactura,
  resetPagoSinFactura,
  validarDatosPagoSinFactura,
  agregarConceptoLiq,
  eliminarConceptoLiq,
  agregarPagoLiq,
  eliminarPagoLiq,
  resetIdLiquidacionSinFactura,
  setIdLiquidacionSinFactura
} = datosPagoSinFacturaSlice.actions

export default datosPagoSinFacturaSlice.reducer